import Client from '../client';
import { AxiosResponse } from 'axios';
import BaseService from '../baseService/baseService';

const ParametroRatingService = 
{
    deletarExcelParametros(fileRequest: any)
    {
        return BaseService.conectarEndpoint(fileRequest, 'rating/excel/deletar', 'excelParametroRatingDeletar');
    },
    parametroRatingExcelPost(fileRequest: any)
    {
        return BaseService.conectarEndpoint(fileRequest, 'rating/excel', 'excelRating');
    },
    obterExcel(): Promise<void | AxiosResponse<any>> 
    {
        return Client.getBlob('rating/excel');
    },
    enviarParametrosAoEventGrid(): Promise<void | AxiosResponse<any>> 
    {
        return Client.post('rating/eventGrid', {});
    }
}

export default ParametroRatingService;